<!-- eslint-disable -->
<template lang="pug">
    div(v-if="user.type !== 'student'")
        list(
            type="presentations",
            :selected-presentation-id="selectedPresentation && selectedPresentation.id",
            :page="$route.query.page",
            :withoutCreate="false",
            :is-education-materials="isEducationMaterials",
            @selectPresentation="selectPresentation",
            @startPresentation="startPresentation"
        )
            .button-container(slot="run")
                cs-button(@click='startPresentation(selectedPresentation)' :disabled="!selectedPresentation")
                    | {{ $i18n.t('presentations.presentations_start') }}
</template>

<script>
    /*eslint-disable*/
    import GameFormMixin from "../../../utils/trainer/GameFormMixin";
    import multiplayerFormMixin from "../../../utils/multiplayer/formMixin";
    import { mapState } from 'vuex';
    import { getInitParameters } from "../../../utils/trainer/getInitParameters";
    import { cloneDeep } from "lodash";
    import TrainerGames from "../../../config/trainer";
    import List from "../../lists/List.vue";

    export default {
        props: [
            'slug',
            'courseType',
            'id',
            'usersIds',
            'homeworkId',
            'gameMode',
            'levelAnswerDuration',
            'gameId',
            'generatorSettings',
            'generatorGameIndex',
            'isEducationMaterials',
        ],
        mixins: [GameFormMixin, multiplayerFormMixin],
        data () {
            return {
                params: null,
                selectedPresentation: null,
            }
        },
        mounted() {
            if (this.gameMode === 'free-game' || this.isEducationMaterials) {
                let paramsArray = this.$store.state.trainer.paramsArray;
                if (paramsArray && paramsArray[0] && paramsArray[0].slug === this.slug) {
                    this.paramsArray = cloneDeep(paramsArray);
                    this.$emit('playersNumber', this.paramsArray.length);
                    this.params = this.paramsArray[0];
                } else if (this.gamesParameters) {
                    this.$set(this, 'params', getInitParameters({
                        slug: this.slug,
                        parameters: {
                            default: cloneDeep(this.gamesParameters[this.slug])
                        }
                    }));
                } else {
                    this.params = cloneDeep(TrainerGames.games).find(item => item.slug === this.slug).parameters.default;
                }
            } else {
                this.setInitParams(this.getKey(this.usersIds));
            }
        },
        methods: {
            selectPresentation (presentation) {
                this.params.presentation = presentation;
                this.selectedPresentation = presentation;
            },
            startPresentation (presentation) {
                this.params.presentation = presentation;
                this.selectedPresentation = presentation;
                if (this.selectedPresentation) {
                    this.$store.dispatch('setGame', this.params);
                    this.$store.dispatch('setParamsArray', this.paramsArray);
                    this.$router.push({name: 'presentations:start'});
                }
            }
        },
        computed: {
            ...mapState({
                homework: state => state.trainer.homework,
                gamesParameters: state => state.trainer.gamesParameters,
                user: state => state.auth.user
            }),
        },
        components: {
            List,
        },
    }
</script>

<style scoped lang="scss">
    .button_with-margin {
        margin-right: 5px;
    }
    .info-text {
        padding: 1rem;
        text-align: center;
        font-size: 1.5rem;
    }

    .button-container {
        display: flex;
        justify-content: center;
        margin-top: 30px;
    }
</style>
